import { useEffect } from "react";
import { parseCookies } from "nookies";

const Newrelic = () => {
  useEffect(() => {
    const setNewRelicConsent = () => {
      const existCookies = parseCookies();
      const countryLang = existCookies.evCntryLang;
      const euCookiePrefs = existCookies.EU_COOKIE_PREFS;
      
      if (!window.newrelic) {
        return false; // NewRelic not loaded yet
      }

      if(!window.cookieCountries) {
        return false; // cookieCountries not set yet
      }

      const countryCode = countryLang ? countryLang.substring(0, 2) : '';

      // updated newrelic 
      if (window.cookieCountries.includes(countryCode)) {
        if (euCookiePrefs && euCookiePrefs.substring(1, 2) === '1') {
          window.newrelic?.consent(true)
        } else {
          window.newrelic?.consent(false)
        }
      } else {
        // country is not enabled for cookie policy
        window.newrelic?.consent(true)
      }
      
      return true; // Successfully set consent
    };

    // Try to set consent immediately
    if (setNewRelicConsent()) {
      return; // Success, no need to retry
    }

    // If NewRelic is not loaded yet, retry with polling
    let retryCount = 0;
    const maxRetries = 20; // Try for up to 2 seconds (20 * 100ms)
    const intervalId = setInterval(() => {
      retryCount++;
      if (setNewRelicConsent() || retryCount >= maxRetries) {
        clearInterval(intervalId);
      }
    }, 100);
    
    return () => clearInterval(intervalId);
  }, []);

  return null; // This component doesn't render anything
};

export default Newrelic;